import React, { useEffect, useState } from 'react';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { numberFormat } from '../../util/araknerdlib';
import { useCurrency } from '../../util/SystemVariables';
import functions from '../../util/functions';

const FeesGroupStructure = ({feesGroup}) => {
    const [structure, setStructure] = useState(null);
    const currency = useCurrency();
    
    useEffect(()=>{
        fetchStructure();
    }, [feesGroup])


    const fetchStructure = async ()=>{
        const server_response = await ajaxSchool.getGroupStructure(feesGroup.id);
        if(server_response.status === "OK"){
            setStructure(server_response.details);
        }else{
            setStructure('404');
        }
    }



    return (
       
                <>
                    {/* Top Info Bar */}
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="text-truncate mr-2" style={{ maxWidth: '180px' }}>
                        <h6 className="font-weight-bold text-dark mb-0 text-truncate">{feesGroup.group_name}</h6>
                        <small className="text-muted text-truncate d-block">{feesGroup.description}</small>
                      </div>
                      <span className="badge-soft-indigo px-2 py-1 d-flex align-items-center" style={{ fontSize: '10px' }}>
                        <i className="fa fa-users mr-1"></i> {numberFormat(feesGroup.total_students)}
                      </span>
                    </div>
            
                    {/* Amount Box - High Visibility */}
                    <div className="rounded-lg p-3 text-center mb-4" style={{ background: '#F8FAFC' }}>
                      <small className="text-muted font-weight-bold text-uppercase" style={{ fontSize: '9px', letterSpacing: '0.05em' }}>Total Fee Amount</small>
                      <h4 className="font-weight-bold mb-3 mt-1" style={{ color: '#4F46E5' }}>
                        <span style={{ fontSize: '12px' }}>{currency}</span> {numberFormat(feesGroup.amount)}
                      </h4>
                     
                    </div>
            
                    {/* Tiny Structure Preview */}
                    <p className="font-weight-bold text-muted text-uppercase mb-2" style={{ fontSize: '12px' }}>Structure Breakdown</p>
                    <div className="overflow-auto custom-scrollbar" style={{ maxHeight: '200px' }}>
                      <ul className="list-unstyled mb-0">
                        {functions.isObject(structure) && structure.votes.map((vote, idx) => (
                          <li key={idx} className="d-flex justify-content-between mb-2 pb-1 border-bottom-dashed">
                            <span className="text-secondary text-truncate mr-2">{vote.vote.vote_name}</span>
                            <span className="font-weight-bold text-dark smal">{numberFormat(vote.amount)}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                </>
                
    
            
    );
};

export default FeesGroupStructure;
